/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import IAgencia from './entidades/agencia';
    
export default class ModeloAgencia {
    public consultarAgencia() {
        return manejadorRest<IRespuesta<IAgencia>>(() => seguridad.get('Agencia/ConsultarListaAgencia'), true);
    }
    public crearAgencia(Agencia: IAgencia) {
        return manejadorRest<IRespuesta<IAgencia>>(() => seguridad.post('Agencia/GuardarAgencia', Agencia));
    }
    public editarAgencia(Agencia: IAgencia) {
        return manejadorRest<IRespuesta<IAgencia>>(() => seguridad.put('Agencia/EditarAgencia', Agencia));
    }
    public eliminarAgencia(Agencia: IAgencia) {
        return manejadorRest<IRespuesta<IAgencia>>(() => seguridad.delete('Agencia/EliminarAgencia', Agencia));
    }

    public agenciaFiltro(Agencia: Partial<IAgencia>) {
        return manejadorRest<IRespuesta<IAgencia>>(() => seguridad.post('Agencia/ConsultarListaAgenciaFiltro', Agencia));
    }
}
